// extracted by mini-css-extract-plugin
module.exports = {"modal":"EditInsurance_modal__3sAvj"};